var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",staticClass:"rkm-modal",attrs:{"buttons":['cancel', 'save'],"extraLarge":"","title":"Medicamento(s) de uso contínuo"},on:{"save":_vm.handleSave}},[_c('Form',{ref:"Form",attrs:{"index":_vm.index,"data":_vm.data},on:{"save":function($event){return _vm.close()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }